import { createFileRoute } from "@tanstack/react-router";
import { BrewSensorySessionList } from "@/features/brew-sensory/brew-sensory-session-list";

export const Route = createFileRoute("/food-app/sensory/")({
  component: BrewSensorySessionList,
});
